import { type FC } from "react";
import { Navigate, useParams } from "react-router";

export const DashboardProjectsDocumentsList: FC = () => {
  const { id } = useParams<{ id: string }>();

  return <Navigate to={`/dashboard/projects/${id}`} replace />;
};
